import { Entity } from '@inter-ikea-core/core';
import { Product } from '@inter-ikea-storageone/range';
import NoProductsOnFilterMessage from 'components/NoProductsOnFilterMessage/NoProductsOnFilterMessage';
import NoneOptionCard from 'components/ProductSidebar/ProductCard/NoneOptionCard';
import ProductCard from 'components/ProductSidebar/ProductCard/ProductCard';
import { List, ListItem } from 'components/ProductSidebar/menus/menuComponents';
import SelectInSceneInfo from 'components/SelectInSceneInfo/SelectInSceneInfo';

type Props = {
  selectedEntity: Entity | null;
  selectedGroupId: string;
  suggestionsForSelectedFrame: Product[];
  handleClick: (product: Product) => void;
  message: string;
  image: string;
  noneOptionForInteriorSuggestions: any;
};

export default function InteriorSuggestionsDesktop({
  selectedEntity,
  selectedGroupId,
  suggestionsForSelectedFrame,
  handleClick,
  message,
  image,
  noneOptionForInteriorSuggestions
}: Props) {
  if (!selectedEntity) {
    return <SelectInSceneInfo message={message} image={image} />;
  }

  return (
    <>
      {suggestionsForSelectedFrame.length === 0 && <NoProductsOnFilterMessage />}
      <List>
        <ListItem key="none-option">
          <NoneOptionCard
            noneOption={noneOptionForInteriorSuggestions}
            currentMenu={selectedGroupId}
          ></NoneOptionCard>
        </ListItem>
        {suggestionsForSelectedFrame.map((product: Product) => (
          <ListItem key={product.coreProductId} data-testid={product.coreProductId}>
            <ProductCard
              product={product}
              handleClick={handleClick}
              infoButtonAriaLabel={'storageone.selectedMenuInteriorsCombinationsMenuTitle'}
            />
          </ListItem>
        ))}
      </List>
    </>
  );
}
